module.exports = __webpack_public_path__ + "static/media/event.cd25bc2a.jpg";